// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import Toggle from "react-toggle";
import styles from "./toggleButton.module.css";

function ToggleButton(props) {
    return (
        <label className={styles.wrapper}>
            <Toggle
                className={styles.toggle}
                defaultChecked={props.value}
                icons={props.showIcons}
                onChange={props.onChange}
            />
            <span className={styles.label}>{props.label}</span>
        </label>
    );
}

export default ToggleButton;
